module.exports = __webpack_public_path__ + "img/logo-header.e35fa82c.png";